import { mangaList } from "@/mocks/mangaList";
import MangaCard from "@/components/feature/MangaCard";
import SectionHeading from "@/components/feature/SectionHeading";

export default function CompletedSection() {
  const completed = mangaList.filter((m) => m.status === "已完结").slice(0, 4);

  return (
    <section className="border-y border-background-200 bg-secondary-50" aria-labelledby="completed-heading">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          title="完结佳作推荐"
          subtitle="经典名作一口气读完,不用担心等更"
          moreTo="/category/completed"
          moreLabel="全部完结作品"
        />
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {completed.map((manga) => (
            <MangaCard key={manga.id} manga={manga} />
          ))}
        </div>
      </div>
    </section>
  );
}